export default __webpack_public_path__ + "static/media/2026-03-22 18.08.22.a83d44ae.jpg";